import React from "react";
import { BadgeCheck } from "lucide-react";
import { LicenseLink } from "../LicenseLink";

export const BrandLogo = ({ t }) => (
  <div className="flex items-center gap-3 md:gap-4 min-w-0">
    <a href="/#top" data-testid="brand-logo" className="flex items-center gap-2.5 group flex-shrink-0">
      <img
        src="/logo-sm.png"
        alt="Tenorio Master Roofing logo"
        data-testid="brand-logo-img"
        className="h-11 md:h-14 w-auto object-contain rounded-md ring-1 ring-brand-border"
      />
      <div className="hidden md:block leading-tight">
        <div className="font-display font-extrabold text-brand-primary text-sm md:text-base">
          Tenorio Master
        </div>
        <div className="text-[10px] md:text-[11px] text-brand-muted font-medium tracking-wider uppercase">
          Roofing
        </div>
      </div>
    </a>
    <LicenseLink
      t={t}
      testId="header-license"
      className="hidden md:flex items-center gap-1.5 border-l border-brand pl-3 md:pl-4 text-brand-primary hover:text-brand-accent transition-colors"
    >
      <BadgeCheck className="w-4 h-4 text-brand-accent flex-shrink-0" strokeWidth={2.5} />
      <span className="font-display font-bold text-sm tracking-tight whitespace-nowrap underline decoration-dotted underline-offset-4 decoration-brand-accent/60">
        {t.footer.licenseHeader}
      </span>
    </LicenseLink>
  </div>
);
